/** Enumération des erreurs possibles non générique pour la saisie d'un frais */
export enum FraisErreur {
    ANOMALIE_PERIODE = 1,
    ANOMALIE_OM_DATE = 6,
    ANOMALIE_QUANTITE_AUTORISEE = 7,
    ANOMALIE_MONTANT_NEGATIF = 8,
    ANOMALIE_DEPENSE_FUTURE = 9,
    ANOMALIE_OM_PERMANENT_DATE = 11,
    
}